/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Button,
  CardMedia,
  Checkbox,
  Dialog,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from '@mui/material';
import { Box } from '@mui/system';
import { Formik, validateYupSchema, yupToFormErrors } from 'formik';
import React, { useEffect, useState } from 'react';
import {
  POAAuthorisedSignatories,
  Groups,
  GroupSignatories,
  ApplicationProps,
  mdmsInvestorProfileQuestion,
  RiskProfileMaster,
  Document,
  DocumentType,
} from '../../redux-store/types/api-types';
import {
  POA_AUTHORIZED_SIGNATORY_INDIVIDUAL_FLOW_VISIBLITY_ENABLE,
  POA_Authorized_signatory_can_Esign_Enable,
  USER_ROLES,
  getGroupNameMaster,
} from '../../utils/constant';
import { DataTable } from '../DataTable';
import AddIcon from '@mui/icons-material/Add';
import InfoIconButton from '../InfoIconButton';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { ProceedSaveLater, SubHeading } from '../investors/components';
import { RequiredFieldsMessage } from '../RequiredFieldsMessage';
import { MFTextField } from '../../lib/formik';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import {
  getDocuments,
  getInvestorProfileData,
  isFormValidForSubmission,
  updateApplication,
} from '../../redux-store/actions/application';
import { useHistory } from 'react-router';
import {
  applicationComparison,
  checkIfApplicationIsIndividualPOA,
  checkIfApplicationIsNonIndividualPOA,
  checkValidationBasedOnDate,
  getArrayLength,
  getUpdatedDocuments,
  preventSpecialCharacters,
  removeSingleQuote,
  saveForLater,
} from '../../utils/utilityFunctions';
import { nonIndividualAuthorisedSignatories } from '../../utils/schema';
import { ConfirmationDialog, CountryCodesDropDown } from '../commonComponents';
import { showError } from '../../redux-store/actions/auth';
import { useSnackbar } from 'notistack';
import { useFeatureToggles } from '../../utils/toggler';
import { nonDigitRegex } from '../../utils/regex';
import { getNationalityList, riskProfileMasterData } from '../../redux-store/actions';
import { nationaliyType } from '../../redux-store/types/mdms';
import { Item, ItemDetails } from '../ApplicationDetails';
import { getFieldTitle } from '../ApplicationDetails/DocumentDetails';
import { documentDetails } from '../investors/documentDetails';

// type GroupsProps = {
//   name: string;
//   threshold: number;
//   groupsignatories: GroupSignatories[];
// };

// export type Values = {
//   groups: GroupsProps[];
//   saveType: string;
// };

export const GroupSignatoriesObject: GroupSignatories = {
  groupId: '',
  name: '',
  pan: '',
  mobile: '',
  countryNameAndCode: 'India: +91',
  countryCode: '+91',
  email: '',
  designation: '',
  canEsign: true,
  isActive: true,
};

// const initialValues: Values = {
//   groups: [
//     {
//       name: '',
//       threshold: 1,
//       groupsignatories: [GroupSignatoriesObject],
//     },
//   ],
//   saveType: 'save and proceed',
// };

const headers = [
  {
    header: 'Name',
    label: 'name',
    valueGetter: (row: GroupSignatories) => row.name || 'N/A',
  },
  {
    header: 'PAN',
    valueGetter: (row: GroupSignatories) => row.pan.toUpperCase() || 'N/A',
  },
  {
    header: 'Email ID',
    valueGetter: (row: GroupSignatories) => row.email || 'N/A',
  },
  {
    header: 'Designation',
    valueGetter: (row: GroupSignatories) => row.designation || 'N/A',
  },
];

export const poaAuthorisedheaders = [
  {
    header: `Name`,
    valueGetter: (row: POAAuthorisedSignatories) => row.user.firstName || 'N/A',
  },
  {
    header: 'Mobile Number',
    valueGetter: (row: POAAuthorisedSignatories) => row.user.phone || 'N/A',
  },
  {
    header: 'Email Id',
    valueGetter: (row: POAAuthorisedSignatories) => row.user.email || 'N/A',
  },
];

const AUTHORISED_SIGNATORY_LABEL = 'Total No. of required authorised signatories for E-sign';

export const Thrashold = ({
  value,
  onChange,
  thrasholdLength = 1,
  disabled = false,
  accessibleLabel = AUTHORISED_SIGNATORY_LABEL,
}: {
  value: number;
  onChange: (e: SelectChangeEvent<number>) => any;
  thrasholdLength?: number;
  disabled?: boolean;
  accessibleLabel?: string;
}): JSX.Element => {
  return (
    <Grid
      sx={{
        display: 'flex',
      }}
      alignItems="center"
      mb={4}
      mt={1}>
      <Typography sx={{ color: 'primary.main', fontSize: '16px' }}>
        Total No. of required authorised signatories for E-sign
        {!disabled && (
          <Typography component="span" sx={{ color: '#BD2932' }}>
            *
          </Typography>
        )}{' '}
        :
      </Typography>{' '}
      {disabled ? (
        <Typography
          component="span"
          sx={{ backgroundColor: 'rgba(97, 209, 214, 0.07)', px: 3, py: 0.5 }}>
          {value}
        </Typography>
      ) : (
        <Box
          sx={{
            width: '100px',
            ml: 2,
            '.MuiOutlinedInput-root': {
              marginTop: '0',
              backgroundColor: 'rgba(97, 209, 214, 0.07)',
              '&.MuiInputBase-root': {
                '& .MuiSelect-select': {
                  padding: '7px 38px',
                  border: 'none',
                },
              },
              '.MuiOutlinedInput-notchedOutline': {
                border: 'none',
              },
            },

            '&.Mui-focused,&:hover': {
              '.MuiOutlinedInput-notchedOutline': {
                borderWidth: 'none',
              },
            },
            svg: {
              color: '#3179C0',
            },
          }}>
          <Select
            onChange={onChange}
            value={value}
            SelectDisplayProps={{
              role: 'combobox',
              'aria-label': accessibleLabel,
            }}
            sx={{
              color: 'primary.main',
              fontWeight: 500,
            }}
            MenuProps={{
              sx: {
                '.MuiPaper-root ': {
                  maxHeight: '20%',
                },
              },
            }}>
            {getArrayLength(thrasholdLength).map((thresholdValue, ind) => (
              <MenuItem
                sx={{
                  borderBottom: '1px solid #ccc',
                  textAlign: 'center',
                  '&:last-child': { border: 'none' },
                  justifyContent: 'center',
                }}
                value={thresholdValue}
                key={ind}>
                {thresholdValue}
              </MenuItem>
            ))}
          </Select>
        </Box>
      )}
    </Grid>
  );
};

type poaAuthSign = {
  authorisedSignatories: POAAuthorisedSignatories[];
  thrashold: number;
};
export const POAAuthorisedSignatoriesFragment = ({
  values,
  onChange,
  authorisedSignatoryValidationDate,
  createdAt,
}: {
  values: poaAuthSign;
  onChange: (param: poaAuthSign) => any;
  authorisedSignatoryValidationDate: string;
  createdAt: string;
}): JSX.Element => {
  const { role = '' } = useSelector((store: RootStateType) => store.auth);

  const isFieldDisabled = ![USER_ROLES.POAAPPROVER].includes(role);

  const sendToEsignCell = {
    header: (): JSX.Element => {
      const [open, setOpen] = useState(false);

      const handleOpen = () => {
        setOpen(true);
      };
      const handleClose = () => {
        setOpen(false);
      };
      return (
        <>
          <Typography
            variant="h6"
            sx={{
              fontFamily: 'Poppins, sans-serif',
              fontSize: 14,
              fontWeight: 500,
              color: 'primary.main',
              pr: 0.5,
            }}
            component="span">
            Send e-sign link
          </Typography>
          <InfoIconButton
            aria-label="More information about Send e-sign link"
            onClick={handleOpen}
            sx={{ position: 'relative', top: 4 }}
          />

          <Dialog
            onClose={handleClose}
            open={open}
            sx={{
              '.MuiPaper-root ': {
                maxWidth: 400,
                p: { xs: 2, sm: '15px 20px 45px' },
                borderRadius: '10px',
                height: 'unset',
                overflowY: 'auto',
              },
            }}>
            <IconButton onClick={handleClose} aria-label="Close" sx={{ alignSelf: 'flex-end' }}>
              <CloseIcon fontSize="medium" />
            </IconButton>
            <Box sx={{ mb: 2, textAlign: 'center', '.MuiSvgIcon-root': { fontSize: '3.1875rem' } }}>
              <InfoOutlinedIcon color="info" fontSize="large" />
            </Box>
            <Box
              sx={{
                width: { xs: '100%', sm: '80%' },
                mx: 'auto',
                '.MuiTypography-root': {
                  fontSize: 20,
                  fontWeight: 500,
                  textAlign: 'center',
                },
              }}>
              <Typography sx={{ color: 'secondary.main', lineHeight: '35px' }}>
                Use this option to send the e-sign link to specific set of authorized signatories.
              </Typography>
            </Box>
          </Dialog>
        </>
      );
    },
    renderEditDeleteCell: (row: POAAuthorisedSignatories, index: number): JSX.Element => {
      return (
        <Checkbox
          checked={row.canEsign}
          inputProps={{
            'aria-label': `Send e-sign link to ${row.name || row.pan}`,
          }}
          sx={{ display: { xs: 'block' }, ':hover': { backgroundColor: 'white' } }}
          onChange={() => {
            const setCanEsign = values.authorisedSignatories.map((signatory, ind) => {
              if (index === ind) {
                return { ...signatory, canEsign: !signatory.canEsign };
              }
              return signatory;
            });

            onChange({ ...values, authorisedSignatories: setCanEsign });
          }}
          disabled={isFieldDisabled}
        />
      );
    },
  };

  return (
    <>
      <Thrashold
        thrasholdLength={values.authorisedSignatories.filter((item) => item.canEsign)?.length}
        value={values.thrashold}
        onChange={(e) =>
          onChange({
            authorisedSignatories: values.authorisedSignatories,
            thrashold: Number(e.target.value),
          })
        }
        disabled={!POA_Authorized_signatory_can_Esign_Enable || isFieldDisabled}
      />
      {/* <Typography sx={{ color: 'primary.main', fontSize: '16px' }} mb={4} mt={1}>
        Total No. of required authorised signatories for E-sign :{' '}
        <Typography
          component="span"
          sx={{ backgroundColor: 'rgba(97, 209, 214, 0.07)', px: 3, py: 0.5 }}>
          {application?.requiredAuthorisedSignatory}
        </Typography>
      </Typography> */}
      {values.authorisedSignatories && values.authorisedSignatories.length !== 0 && (
        <>
          <Grid xs={12} sm={12} lg={12}>
            <DataTable
              tableData={values.authorisedSignatories}
              tableHeader={[
                ...(POA_Authorized_signatory_can_Esign_Enable ? [sendToEsignCell] : []),
                ...poaAuthorisedheaders,
              ]}
              caption="Authorised Signatory information"
              renderAdditionalRow={false}
              tableHeaderCustomStyles={{
                '.MuiTableCell-head': {
                  fontFamily: 'Poppins, sans-serif',
                  fontSize: 14,
                  fontWeight: 500,
                  color: 'primary.main',
                },
              }}
              rowCustomStyles={{
                '.MuiTableCell-root': {
                  py: '8px',
                  overflowWrap: 'anywhere',
                },
              }}
              boxStyles={{ minHeight: '0px', minWidth: 450 }}
            />
          </Grid>
          <Grid container pt={3}>
            {checkValidationBasedOnDate(createdAt, authorisedSignatoryValidationDate) &&
              values.authorisedSignatories
                // .filter((item) => item.canEsign)
                .map((signatory, index) => {
                  const updatedDocuments = getUpdatedDocuments(
                    signatory?.poasignatorydocuments || []
                  );
                  return (
                    <React.Fragment key={index}>
                      {/* <Grid item xs={12}> */}
                      <SubHeading>{signatory.user.firstName}</SubHeading>
                      {/* </Grid> */}
                      {updatedDocuments?.length ? (
                        updatedDocuments.map((document, index: number) => {
                          return (
                            <React.Fragment key={document.id}>
                              <Grid
                                item
                                xs={12}
                                sm={6}
                                md={document.file ? 6 : 12}
                                sx={{
                                  pl: { xs: 0, sm: 7, md: 10, lg: 13 },
                                  mt: index !== 0 ? { sm: 8, xs: 2 } : 2,
                                }}>
                                {/* <Item>{document.documentType}</Item> */}
                                <Item>{getFieldTitle[document.documentType]}</Item>
                                {document.documentType === 'investorSignature' && (
                                  <Typography
                                    sx={{
                                      fontWeight: 400,
                                      fontSize: 14,
                                    }}>
                                    (This signature copy is used as a verification process for
                                    future redemptions and transfer requests)
                                  </Typography>
                                )}
                                <ItemDetails>
                                  {document.documentName?.toLowerCase() ===
                                  getFieldTitle[document.documentType]?.toLowerCase()
                                    ? document.file?.name
                                    : document.documentName}
                                </ItemDetails>
                              </Grid>
                              {document.file && (
                                <Grid item xs={12} sm={6}>
                                  <Box
                                    sx={{
                                      display: 'flex',
                                      mt: index !== 0 ? { sm: 8, xs: 2 } : 2,
                                      flexDirection: { sm: 'column', xs: 'row', md: 'row' },
                                    }}>
                                    <Button
                                      variant="contained"
                                      sx={{
                                        color: 'common.white',
                                        // minWidth: { xs: '90%', sm: '100%', md: '70%' },
                                        minWidth: '70%',
                                        // mt: index !== 0 ? { sm: 8, xs: 2 } : 2,
                                        fontWeight: 600,
                                        lineHeight: 1.5,
                                      }}
                                      onClick={() => window.open(document.file?.viewUrl)}>
                                      View
                                    </Button>
                                    <Tooltip title={'Download'}>
                                      <IconButton
                                        aria-label="Download document"
                                        sx={{
                                          // p: 0,
                                          // pl: 1.5,
                                          ':hover': {
                                            bgcolor: '#F4FCFC',
                                          },
                                          cursor: 'pointer',
                                          pointerEvents: 'all',
                                          // mt: index !== 0 ? { sm: 8, xs: 2 } : 2,
                                        }}
                                        onClick={() => window.open(document.file?.url)}>
                                        <CardMedia
                                          component="img"
                                          src={'/images/download-icon.png'}
                                          alt="Download"
                                          sx={{ width: '25px' }}
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  </Box>
                                </Grid>
                              )}
                            </React.Fragment>
                          );
                        })
                      ) : (
                        <Box
                          sx={{
                            width: '100%',
                            textAlign: 'center',
                          }}>
                          <Typography
                            sx={{
                              // fontSize: 18,
                              // fontWeight: 500,
                              color: 'rgb(97, 209, 214)',
                              // mt: { lg: 14, xs: 4 },
                              // mb: { xs: 4 },
                            }}>
                            No Document
                          </Typography>
                        </Box>
                      )}
                    </React.Fragment>
                  );
                })}
          </Grid>
        </>
      )}
    </>
  );
};

export default function AuthorisedSignatories(): JSX.Element {
  const [authorisedSignatoriesGroup, setAuthorisedSignatoriesGroup] = useState<Groups[]>([]);
  const [authorisedSignatories, setAuthorisedSignatories] = useState(GroupSignatoriesObject);
  const [loading, setLoading] = useState(false);
  const [saveType, setSaveType] = useState('');
  const [open, setOpen] = useState(false);
  const { application } = useSelector((store: RootStateType) => store.application);
  // const [thresholdValue, setThresholdValue] = useState(1);
  const [groupIndex, setGroupIndex] = useState(Number);
  const [rowIndex, setRowIndex] = useState(Number);
  const history = useHistory();
  const dispatch = useDispatch();
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const [deletePopup, setDeletePopup] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const [authorisedSignatoriesPOA, setAuthorisedSignatoriesPOA] = useState<{
    authorisedSignatories: POAAuthorisedSignatories[];
    thrashold: number;
  }>({
    authorisedSignatories: application?.poaauthorisedsignatories || [],
    thrashold: application?.requiredAuthorisedSignatory || 0,
  });

  const dateFeatureToggles = useFeatureToggles();

  const { nomineeValidationDate, poaValidationDate, authorisedSignatoryDocValidationDate } =
    dateFeatureToggles;

  useEffect(() => {
    (async function () {
      try {
        const { groups = [] } = application || {};
        setAuthorisedSignatoriesGroup(
          groups.length
            ? groups.map((group) => {
                return {
                  ...group,
                  groupsignatories: group.groupsignatories.map((signatory) => {
                    return {
                      ...signatory,
                      countryCode: signatory.countryCode ? signatory.countryCode : '+91',
                      countryNameAndCode: signatory.countryNameAndCode
                        ? signatory.countryNameAndCode
                        : 'India: +91',
                    };
                  }),
                };
              })
            : [
                {
                  name: '',
                  threshold: 1,
                  groupsignatories: [],
                },
              ]
        );
        setAuthorisedSignatoriesPOA({
          authorisedSignatories: application?.poaauthorisedsignatories || [],
          thrashold: application?.requiredAuthorisedSignatory || 0,
        });
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, [application]);

  const handleClose = () => {
    setAuthorisedSignatories(GroupSignatoriesObject),
      setRowIndex(Number),
      setGroupIndex(Number),
      setOpen(false);
  };

  const onSubmit = (values: GroupSignatories) => {
    const editsignatory = authorisedSignatoriesGroup[groupIndex].groupsignatories
      .filter((_item) => _item.isActive)
      .map((signatory, _ind) => {
        if (rowIndex === _ind) {
          return { ...values, countryCode: values.countryNameAndCode.split(':')[1].trim() };
        }
        return signatory;
      });
    const deletedsignatory = authorisedSignatoriesGroup[groupIndex].groupsignatories.filter(
      (_item) => !_item.isActive && _item.id
    );

    const addSignatoriesGroup = authorisedSignatoriesGroup.map((group, ind) => {
      if (ind === groupIndex) {
        return {
          ...group,
          name: getGroupNameMaster[groupIndex],
          threshold: group.threshold,
          groupsignatories: [
            authorisedSignatories.pan,
            authorisedSignatories.mobile,
            authorisedSignatories.email,
          ].includes('')
            ? [
                ...group.groupsignatories,
                { ...values, countryCode: values.countryNameAndCode.split(':')[1].trim() },
              ]
            : [...editsignatory, ...deletedsignatory],
        };
      }
      return group;
    });
    setAuthorisedSignatoriesGroup(addSignatoriesGroup);
    handleClose();
  };

  const handleSubmit = async (saveTypeText: string) => {
    try {
      const { id, applicant1ReferenceId = '', currentStep, applicationNumber } = application || {};
      if (
        !checkIfApplicationIsNonIndividualPOA(application as ApplicationProps) &&
        !checkIfApplicationIsIndividualPOA(application as ApplicationProps)
      ) {
        authorisedSignatoriesGroup.map((group) => {
          const getActiveSignatories = group.groupsignatories.filter((item) => item.isActive);
          const getCanEsignCount = getActiveSignatories.filter((item) => item.canEsign);
          if (!getActiveSignatories.length) {
            throw 'Please add Authorised Signatories';
          }
          if (!getCanEsignCount.length) {
            throw 'Please Select a member for E-Sign';
          }
          if (getCanEsignCount.length < group.threshold) {
            throw 'Authorised Signatories that can esign can not be less than the Total No. of required Authorised Signatories';
          }
          return group;
        });
      } else if (
        application &&
        checkValidationBasedOnDate(application?.createdAt || '', poaValidationDate) &&
        (checkIfApplicationIsNonIndividualPOA(application as ApplicationProps) ||
          (checkIfApplicationIsIndividualPOA(application) &&
            POA_AUTHORIZED_SIGNATORY_INDIVIDUAL_FLOW_VISIBLITY_ENABLE)) &&
        POA_Authorized_signatory_can_Esign_Enable
      ) {
        const getCanEsignCount = authorisedSignatoriesPOA.authorisedSignatories?.filter(
          (item) => item.canEsign
        );
        if (!authorisedSignatoriesPOA.authorisedSignatories?.length) {
          throw 'Please add Authorised Signatories';
        }
        if (!getCanEsignCount.length) {
          throw 'Please Select a member for E-Sign';
        }
        if (getCanEsignCount.length < authorisedSignatoriesPOA.thrashold) {
          throw 'Authorised Signatories that can esign can not be less than the Total No. of required Authorised Signatories';
        }
      }

      if (checkIfApplicationIsIndividualPOA(application as ApplicationProps)) {
        const nationalitiesMdmsMasters = (await dispatch(
          getNationalityList()
        )) as unknown as nationaliyType;
        const risk = (await dispatch(riskProfileMasterData())) as unknown as RiskProfileMaster;
        const questionsInvestor = (await dispatch(
          getInvestorProfileData()
        )) as unknown as mdmsInvestorProfileQuestion;
        const documentsData = (await dispatch(getDocuments())) as unknown as Document;
        await isFormValidForSubmission(
          application,
          risk,
          questionsInvestor.investor_question_individual,
          dateFeatureToggles,
          false,
          true,
          nationalitiesMdmsMasters,
          documentsData,
          role
        );
      }
      const Poa_can_esign =
        POA_Authorized_signatory_can_Esign_Enable &&
        checkValidationBasedOnDate(application?.createdAt || '', poaValidationDate)
          ? {
              poaauthorisedsignatories:
                checkIfApplicationIsNonIndividualPOA(application as ApplicationProps) ||
                checkIfApplicationIsIndividualPOA(application as ApplicationProps)
                  ? authorisedSignatoriesPOA.authorisedSignatories
                  : application?.poaauthorisedsignatories,
              requiredAuthorisedSignatory:
                checkIfApplicationIsNonIndividualPOA(application as ApplicationProps) ||
                checkIfApplicationIsIndividualPOA(application as ApplicationProps)
                  ? authorisedSignatoriesPOA.thrashold
                  : application?.requiredAuthorisedSignatory,
            }
          : {};

      const updatedApplication = {
        ...application,
        ...Poa_can_esign,
        groups:
          checkIfApplicationIsNonIndividualPOA(application as ApplicationProps) ||
          checkIfApplicationIsIndividualPOA(application as ApplicationProps)
            ? application?.groups
            : authorisedSignatoriesGroup.map((group) => ({
                ...group,
                groupsignatories: group.groupsignatories.map((groupsignatory) => ({
                  ...groupsignatory,
                  name: removeSingleQuote(groupsignatory.name),
                  designation: removeSingleQuote(groupsignatory.designation),
                  email: removeSingleQuote(groupsignatory.email),
                })),
                isActive: true,
              })),
      };

      const checkApplication = applicationComparison(
        {
          ...application,
        },
        {
          ...updatedApplication,
          currentStep:
            !!currentStep &&
            currentStep >
              (checkIfApplicationIsIndividualPOA(application as ApplicationProps)
                ? !checkValidationBasedOnDate(application?.createdAt || '', nomineeValidationDate)
                  ? 10
                  : 9
                : 7)
              ? currentStep
              : Number(currentStep) + 1,
        }
      );
      if (id && !checkApplication) {
        setSaveType(saveTypeText);
        setLoading(true);
        await dispatch(
          updateApplication({
            body: {
              ...updatedApplication,
              currentStep: checkIfApplicationIsIndividualPOA(application as ApplicationProps)
                ? !checkValidationBasedOnDate(application?.createdAt || '', nomineeValidationDate)
                  ? 11
                  : 10
                : 8,
            },
            applicationId: id,
            ...(saveTypeText !== 'save and proceed' && {
              toastMessage: '',
            }),
          })
        );
        if (checkIfApplicationIsIndividualPOA(application as ApplicationProps)) {
          history.push(
            role === USER_ROLES.INVESTOR
              ? `/investment-details/${applicant1ReferenceId}/application-details`
              : role === USER_ROLES.POAAPPROVER || USER_ROLES.AMCAPPROVER === role
              ? `/application-details/${id}`
              : saveTypeText !== 'save and proceed'
              ? `/applications`
              : `/application-preview/${id}`
          );
        } else {
          saveTypeText === 'save and proceed'
            ? history.push('declaration-ubo', { id, applicant1ReferenceId })
            : history.push(saveForLater(role, id, applicant1ReferenceId));
        }
      } else if (checkApplication) {
        if (saveTypeText !== 'save and proceed') {
          enqueueSnackbar(`Application ${applicationNumber} - ` + ' Saved successfully', {
            variant: 'success',
            autoHideDuration: 3000,
          });
        }
        if (checkIfApplicationIsIndividualPOA(application as ApplicationProps)) {
          history.push(
            role === USER_ROLES.INVESTOR
              ? `/investment-details/${applicant1ReferenceId}/application-details`
              : role === USER_ROLES.POAAPPROVER || USER_ROLES.AMCAPPROVER === role
              ? `/application-details/${id}`
              : saveTypeText !== 'save and proceed'
              ? `/applications`
              : `/application-preview/${id}`
          );
        } else {
          saveTypeText === 'save and proceed'
            ? history.push('declaration-ubo', { id, applicant1ReferenceId })
            : history.push(saveForLater(role, id, applicant1ReferenceId));
        }
      }
    } catch (e) {
      setLoading(false);
      typeof e === 'string' && dispatch(showError(e));
      console.error((e as Error).message);
    }
  };

  const editCell = {
    header: '',
    renderEditDeleteCell: (
      row: GroupSignatories,
      index: number,
      _groupIndex?: number
    ): JSX.Element => {
      return (
        <Box display="flex">
          <Tooltip title="Edit">
            <IconButton
              aria-label="Edit signatory"
              onClick={() => {
                setAuthorisedSignatories(row),
                  typeof _groupIndex !== 'undefined' && setGroupIndex(_groupIndex),
                  setRowIndex(index),
                  setOpen(true);
              }}
              sx={{
                ':hover': {
                  bgcolor: '#F4FCFC',
                },
              }}>
              <EditIcon sx={{ color: 'primary.main' }} fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete">
            <IconButton
              aria-label="Delete signatory"
              onClick={() => {
                setAuthorisedSignatories(row),
                  typeof _groupIndex !== 'undefined' && setGroupIndex(_groupIndex),
                  setRowIndex(index),
                  setDeletePopup(true);
              }}
              sx={{
                ':hover': {
                  bgcolor: '#F4FCFC',
                },
              }}>
              <DeleteOutlineIcon color="error" fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      );
    },
  };

  const sendToEsignCell = {
    header: (): JSX.Element => {
      const [open, setOpen] = useState(false);

      const handleOpen = () => {
        setOpen(true);
      };
      const handleClose = () => {
        setOpen(false);
      };
      return (
        <>
          <Typography
            variant="h6"
            sx={{
              fontFamily: 'Poppins, sans-serif',
              fontSize: 14,
              fontWeight: 500,
              color: 'primary.main',
              pr: 0.5,
            }}
            component="span">
            Send e-sign link
          </Typography>
          <InfoIconButton
            aria-label="More information about Send e-sign link"
            onClick={handleOpen}
            sx={{ position: 'relative', top: 4 }}
          />

          <Dialog
            onClose={handleClose}
            open={open}
            sx={{
              '.MuiPaper-root ': {
                maxWidth: 400,
                p: { xs: 2, sm: '15px 20px 45px' },
                borderRadius: '10px',
                height: 'unset',
                overflowY: 'auto',
              },
            }}>
            <IconButton onClick={handleClose} aria-label="Close" sx={{ alignSelf: 'flex-end' }}>
              <CloseIcon fontSize="medium" />
            </IconButton>
            <Box sx={{ mb: 2, textAlign: 'center', '.MuiSvgIcon-root': { fontSize: '3.1875rem' } }}>
              <InfoOutlinedIcon color="info" fontSize="large" />
            </Box>
            <Box
              sx={{
                width: { xs: '100%', sm: '80%' },
                mx: 'auto',
                '.MuiTypography-root': {
                  fontSize: 20,
                  fontWeight: 500,
                  textAlign: 'center',
                },
              }}>
              <Typography sx={{ color: 'secondary.main', lineHeight: '35px' }}>
                Use this option to send the e-sign link to specific set of authorized signatories.
              </Typography>
            </Box>
          </Dialog>
        </>
      );
    },
    renderEditDeleteCell: (
      row: GroupSignatories,
      index: number,
      group_Index?: number
    ): JSX.Element => {
      return (
        <Checkbox
          checked={row.canEsign}
          inputProps={{
            'aria-label': `Send e-sign link to ${row.name || row.pan}`,
          }}
          // defaultChecked
          sx={{ display: { xs: 'block' }, ':hover': { backgroundColor: 'white' } }}
          onChange={() => {
            const setCanEsign = authorisedSignatoriesGroup.map((group, ind) => {
              if (ind === group_Index) {
                return {
                  ...group,
                  name: getGroupNameMaster[group_Index],
                  threshold: group.threshold,
                  groupsignatories: [
                    ...group.groupsignatories
                      .filter((_item) => _item.isActive)
                      .map((signatory, _ind) => {
                        if (index === _ind) {
                          return { ...signatory, canEsign: !signatory.canEsign };
                        }
                        return signatory;
                      }),
                    ...authorisedSignatoriesGroup[groupIndex].groupsignatories.filter(
                      (_item) => !_item.isActive && _item.id
                    ),
                  ],
                };
              }
              return group;
            });

            setAuthorisedSignatoriesGroup(setCanEsign);
          }}
        />
      );
    },
  };
  const [mobileElementWidth, setMobileElementWidth] = useState(null);
  useEffect(() => {
    const mobileElement = document.getElementsByName('mobile');
    setMobileElementWidth(mobileElement[0]?.parentElement?.clientWidth as any);
  }, []);
  return (
    <>
      <Grid
        container
        rowSpacing={1}
        //columnSpacing={5}
        sx={{
          width: '100%',
          ml: 0,
          '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
        }}>
        {checkIfApplicationIsNonIndividualPOA(application as ApplicationProps) ||
        checkIfApplicationIsIndividualPOA(application as ApplicationProps) ? (
          <POAAuthorisedSignatoriesFragment
            onChange={(e) => setAuthorisedSignatoriesPOA(e)}
            values={authorisedSignatoriesPOA}
            authorisedSignatoryValidationDate={authorisedSignatoryDocValidationDate}
            createdAt={application?.createdAt || ''}
          />
        ) : (
          <>
            {authorisedSignatoriesGroup.map((group, index) => (
              <React.Fragment key={index}>
                <Thrashold
                  thrasholdLength={
                    group.groupsignatories.filter((_signatory) => _signatory.isActive).length
                  }
                  accessibleLabel={`${AUTHORISED_SIGNATORY_LABEL} `}
                  value={group.threshold}
                  onChange={(e) => {
                    const updatethreshold = authorisedSignatoriesGroup.map((_group, _ind) => {
                      if (index === _ind) {
                        return {
                          ..._group,
                          threshold: Number(e?.target?.value),
                        };
                      }
                      return _group;
                    });
                    setAuthorisedSignatoriesGroup(updatethreshold);
                  }}
                />
                {group.groupsignatories.filter((_signatory) => _signatory.isActive).length !==
                  0 && (
                  <Grid xs={12} sm={12} lg={12}>
                    <DataTable
                      groupIndex={index}
                      tableData={group.groupsignatories.filter((_signatory) => _signatory.isActive)}
                      tableHeader={[sendToEsignCell, ...headers, editCell]}
                      caption="Authorised Signatory information"
                      renderAdditionalRow={false}
                      tableHeaderCustomStyles={{
                        '.MuiTableCell-head': {
                          fontFamily: 'Poppins, sans-serif',
                          fontSize: 14,
                          fontWeight: 500,
                          color: 'primary.main',
                        },
                      }}
                      rowCustomStyles={{
                        '.MuiTableCell-root': {
                          py: '8px',
                          overflowWrap: 'anywhere',
                        },
                      }}
                      boxStyles={{ minHeight: '0px', minWidth: 450 }}
                    />
                  </Grid>
                )}
                {group.groupsignatories.filter((item) => item.isActive).length < 20 && (
                  <Grid
                    xs={12}
                    sm={12}
                    lg={12}
                    display="flex"
                    sx={{
                      justifyContent: {
                        xs:
                          group.groupsignatories.filter((_signatory) => _signatory.isActive)
                            .length === 0
                            ? 'start'
                            : 'center',
                        sm:
                          group.groupsignatories.filter((_signatory) => _signatory.isActive)
                            .length === 0
                            ? 'start'
                            : 'end',
                      },
                    }}>
                    <Button
                      variant="outlined"
                      startIcon={<AddIcon />}
                      sx={{
                        color: 'primary.main',
                        fontWeight: 500,
                        fontSize: 13,
                        mr: 2.5,
                        whiteSpace: 'nowrap',
                        mt: '20px',
                      }}
                      onClick={() => {
                        setAuthorisedSignatories(GroupSignatoriesObject),
                          setGroupIndex(index),
                          setOpen(true);
                      }}>
                      Add Authorised Signatory
                    </Button>
                  </Grid>
                )}
              </React.Fragment>
            ))}
          </>
        )}
        <ProceedSaveLater
          saveLater={() => {
            handleSubmit('save for later');
          }}
          saveAndProceed={() => {
            handleSubmit('save and proceed');
          }}
          showEndIcon={
            checkIfApplicationIsIndividualPOA(application as ApplicationProps) ? false : true
          }
          saveButtonText={
            USER_ROLES.AMCAPPROVER === role &&
            checkIfApplicationIsIndividualPOA(application as ApplicationProps)
              ? 'Save Application'
              : checkIfApplicationIsIndividualPOA(application as ApplicationProps)
              ? 'Preview'
              : undefined
          }
          loader={loading}
          clickedButton={saveType}
        />

        <Dialog
          onClose={handleClose}
          open={open}
          aria-labelledby="authorised-member-dialog-title"
          PaperProps={{
            'aria-labelledby': 'authorised-member-dialog-title',
          }}
          sx={{
            '.MuiPaper-root ': {
              p: 4,
              width: { xs: '70%', sm: '70%' },
              pt: 2,
            },
          }}>
          <IconButton onClick={handleClose} aria-label="Close" sx={{ alignSelf: 'flex-end' }}>
            <CloseIcon fontSize="small" />
          </IconButton>
          <Box
            sx={{
              width: { xs: '100%', sm: '80%' },
              mx: 'auto',
              '.MuiTypography-root': {
                textAlign: 'center',
              },
              '.MuiFormControl-root': { my: 1 },
              px: { xs: '0', sm: 5 },
            }}>
            <Typography
              id="authorised-member-dialog-title"
              component="h2"
              sx={{
                color: '#0D2762',
                position: 'relative',
                bottom: '20px',
                fontSize: '23px',
                fontWeight: 500,
              }}>
              {authorisedSignatories.pan ? 'Edit Member' : 'Add Member'}
            </Typography>

            <RequiredFieldsMessage />
            <Formik
              initialValues={authorisedSignatories}
              onSubmit={onSubmit}
              //validationSchema={nonIndividualAuthorisedSignatories}
              validate={(values: GroupSignatories) => {
                const setValuesForEdit = authorisedSignatoriesGroup.map((group, _ind) => {
                  if (_ind === groupIndex) {
                    return {
                      ...group,
                      groupsignatories: group.groupsignatories
                        .filter((_signatory) => _signatory.isActive)
                        .map((_signatory, index) => {
                          if (index === rowIndex) {
                            if (
                              values.pan !== _signatory.pan &&
                              values.mobile !== _signatory.mobile &&
                              values.email !== _signatory.email
                            ) {
                              return _signatory;
                            }
                            if (
                              values.pan === _signatory.pan &&
                              values.mobile === _signatory.mobile &&
                              values.email === _signatory.email
                            ) {
                              const { mobile, email, pan, ...rest } = _signatory;
                              return { ...rest };
                            }
                            if (
                              values.pan !== _signatory.pan &&
                              values.mobile === _signatory.mobile &&
                              values.email === _signatory.email
                            ) {
                              const { mobile, email, ...rest } = _signatory;
                              return { ...rest };
                            }
                            if (
                              values.pan === _signatory.pan &&
                              values.mobile !== _signatory.mobile &&
                              values.email === _signatory.email
                            ) {
                              const { pan, email, ...rest } = _signatory;
                              return { ...rest };
                            }
                            if (
                              values.pan === _signatory.pan &&
                              values.mobile === _signatory.mobile &&
                              values.email !== _signatory.email
                            ) {
                              const { mobile, pan, ...rest } = _signatory;
                              return { ...rest };
                            }
                            if (
                              values.pan !== _signatory.pan &&
                              values.mobile !== _signatory.mobile &&
                              values.email === _signatory.email
                            ) {
                              const { email, ...rest } = _signatory;
                              return { ...rest };
                            }
                            if (
                              values.pan !== _signatory.pan &&
                              values.mobile === _signatory.mobile &&
                              values.email !== _signatory.email
                            ) {
                              const { mobile, ...rest } = _signatory;
                              return { ...rest };
                            }
                            if (
                              values.pan === _signatory.pan &&
                              values.mobile !== _signatory.mobile &&
                              values.email !== _signatory.email
                            ) {
                              const { pan, ...rest } = _signatory;
                              return { ...rest };
                            }
                            return;
                          }
                          return _signatory;
                        }),
                    };
                  }
                  return group;
                });

                try {
                  validateYupSchema(
                    values,
                    nonIndividualAuthorisedSignatories,
                    true,
                    authorisedSignatories.pan
                      ? setValuesForEdit
                      : authorisedSignatoriesGroup.map((_group) => {
                          return {
                            ..._group,
                            groupsignatories: _group.groupsignatories.filter(
                              (_signatory) => _signatory.isActive
                            ),
                          };
                        })
                  );
                } catch (e) {
                  return yupToFormErrors(e);
                }
              }}
              enableReinitialize={true}>
              {({ handleSubmit, setFieldValue, values }) => (
                <Box component="form" noValidate onSubmit={handleSubmit}>
                  <Grid item xs={12}>
                    <MFTextField name={`name`} label="Name" placeholder="Enter Name" required />
                  </Grid>
                  <Grid item xs={12}>
                    <MFTextField
                      name={`pan`}
                      label="PAN"
                      placeholder="Enter Pan"
                      inputProps={{ style: { textTransform: 'uppercase' } }}
                      onChange={(e) => {
                        setFieldValue('pan', e.target.value.toUpperCase());
                      }}
                      required
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <MFTextField
                      name={`mobile`}
                      label={`Mobile Number`}
                      placeholder="Enter Mobile Number"
                      onKeyDown={(e) => {
                        preventSpecialCharacters(e);
                      }}
                      startAdornment={
                        <CountryCodesDropDown
                          ElementWidth={mobileElementWidth && mobileElementWidth}
                          name={`countryNameAndCode`}
                          value={values.countryNameAndCode}
                        />
                      }
                      regexForFilterValue={nonDigitRegex}
                      required
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <MFTextField
                      name={`email`}
                      label="Email ID (Office ID Only)"
                      placeholder="Enter Email ID"
                      required
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <MFTextField
                      name={`designation`}
                      label="Designation"
                      placeholder="Enter Designation"
                      required
                    />
                  </Grid>
                  <Grid xs={12} sm={12} lg={12} display="flex" sx={{ justifyContent: 'center' }}>
                    <Button
                      variant="contained"
                      sx={{
                        fontSize: 15,
                        minWidth: 180,
                        letterSpacing: 2,
                        fontWeight: 500,
                        alignSelf: 'center',
                        mt: 2,
                      }}
                      type="submit">
                      {authorisedSignatories.pan ? 'Save' : 'Add'}
                    </Button>
                  </Grid>
                </Box>
              )}
            </Formik>
          </Box>
        </Dialog>
        <ConfirmationDialog
          message={'Are you sure you want to delete Member ?'}
          open={deletePopup}
          setOpen={() => setDeletePopup(false)}
          onSave={() => {
            setDeletePopup(false);
            const deleteSignatory = authorisedSignatoriesGroup.map((group, ind) => {
              if (ind === groupIndex) {
                return {
                  ...group,
                  name: getGroupNameMaster[groupIndex],
                  threshold: group.threshold,
                  groupsignatories: group.groupsignatories
                    .filter((_item) => _item.isActive)
                    .map((signatory, _ind) => {
                      if (rowIndex === _ind) {
                        return { ...signatory, isActive: false };
                      }
                      return signatory;
                    }),
                };
              }
              return group;
            });

            // const deletedSignatory = authorisedSignatoriesGroup.map((group, _ind) => {
            //   if (_ind === groupIndex) {
            //     return {
            //       ...group,
            //       name: getGroupNameMaster[groupIndex],
            //       threshold: group.threshold,
            //       groupsignatories: group.groupsignatories.filter(
            //         (_signatory) => !_signatory.isActive && _signatory.id
            //       ),
            //     };
            //   }
            //   return group;
            // });
            const active_DeletedSignatory = deleteSignatory.map((group, _ind) => {
              if (_ind === groupIndex) {
                return {
                  ...group,
                  name: getGroupNameMaster[groupIndex],
                  threshold: group.threshold,
                  groupsignatories: [
                    ...authorisedSignatoriesGroup[groupIndex].groupsignatories.filter(
                      (_signatory) => !_signatory.isActive && _signatory.id
                    ),
                    ...group.groupsignatories.filter(
                      (_signatory) => _signatory.isActive || (!_signatory.isActive && _signatory.id)
                    ),
                  ],
                };
              }
              return group;
            });
            //const setAuthorisedSignatories=deleteSignatory[groupIndex].groupsignatories:[...active_DeletedSignatory[groupIndex].groupsignatories,...deleteSignatory[groupIndex].groupsignatories]
            setAuthorisedSignatoriesGroup(active_DeletedSignatory);
            setAuthorisedSignatories(GroupSignatoriesObject),
              setRowIndex(Number),
              setGroupIndex(Number);
            // try {
            //   const deleteSignatory = authorisedSignatoriesGroup.map((group, ind) => {
            //     if (ind === groupIndex) {
            //       return {
            //         ...group,
            //         name: getGroupNameMaster[groupIndex],
            //         threshold: group.threshold,
            //         groupsignatories: group.groupsignatories.map((signatory, _ind) => {
            //           if (rowIndex === _ind) {
            //             return { ...signatory, isActive: false };
            //           }
            //           return signatory;
            //         }),
            //       };
            //     }
            //     return group;
            //   });
            //   authorisedSignatoriesGroup.map((group) => {
            //     const getCanEsignCount = group.groupsignatories.filter((item) => item.canEsign);
            //     if (getCanEsignCount.length < group.threshold) {
            //       throw 'Authorised Signatories that can esign cannot be less than the threshold';
            //     }
            //     return group;
            //   });
            //   const { id } = application || {};
            //   if (id && authorisedSignatories.groupId) {
            //     await dispatch(
            //       updateApplication({
            //         body: {
            //           ...application,
            //           groups: deleteSignatory,
            //         },
            //         applicationId: id,
            //       })
            //     );
            //     return;
            //   }
            //   const deletedSignatories = deleteSignatory.map((group, _ind) => {
            //     if (_ind === groupIndex) {
            //       return {
            //         ...group,
            //         name: getGroupNameMaster[groupIndex],
            //         threshold: group.threshold,
            //         groupsignatories: group.groupsignatories.filter(
            //           (_signatory) => _signatory.isActive
            //         ),
            //       };
            //     }
            //     return group;
            //   });
            //   setAuthorisedSignatoriesGroup(deletedSignatories);
            //   setAuthorisedSignatories(GroupSignatoriesObject),
            //     setRowIndex(Number),
            //     setGroupIndex(Number);
            // } catch (e) {
            //   //typeof e === 'string' && dispatch(showError(e));
            //   console.error((e as Error).message);
            // }
          }}
          onCancel={() => {
            setAuthorisedSignatories(GroupSignatoriesObject),
              setRowIndex(Number),
              setGroupIndex(Number),
              setDeletePopup(false);
          }}
        />
      </Grid>
    </>
  );
}
